import { render, staticRenderFns } from "./realdata.vue?vue&type=template&id=1920da2a&scoped=true"
import script from "./realdata.vue?vue&type=script&lang=js"
export * from "./realdata.vue?vue&type=script&lang=js"
import style0 from "./realdata.vue?vue&type=style&index=0&id=1920da2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1920da2a",
  null
  
)

export default component.exports